import { FaDelicious } from 'react-icons/fa';
import { BsPeopleFill, BsPersonPlus, BsPersonCheckFill, BsPersonCircle } from "react-icons/bs";
import { FaChartColumn, FaUsers, FaUserPlus, FaUserCheck, FaFileLines, FaGears, FaChartSimple, FaFilePen, FaArrowUpWideShort } from "react-icons/fa6";
import { RiAdminFill } from "react-icons/ri";
import { BiSolidUserDetail } from 'react-icons/bi';
import { GrTechnology } from "react-icons/gr";
import { TbReportSearch } from "react-icons/tb";
import { LiaUserPlusSolid } from "react-icons/lia";
import { LuFileCog, LuFileSymlink, LuFileScan, LuFilePenLine, LuFileSliders, LuFileType2, LuFileUser, LuFileTerminal } from "react-icons/lu";
import { GrDatabase } from "react-icons/gr";
import { hasPermission } from "../security/authContext.js";
import { AUTH_CODE } from '../security/authCodes.js';
import { loggedInUserDetails } from '../utils/helper.js';

const loginUser = loggedInUserDetails();
export const GLOBAL_MENU = [
    { name: 'Dashboard', icon: <FaChartColumn />, path: '/dashboard', permission: "" }, // no need to protect that side bar it will protect by inter code 
    {
        name: 'Publisher', icon: <FaUsers />, path: '',
        children: [
            { name: 'Add Publisher', icon: <FaUserPlus />, path: '/Add-Publisher', permission: AUTH_CODE.accounts.createPublisher },
            { name: 'Active Publisher', icon: <FaUserCheck />, path: '/active-publisher', permission: AUTH_CODE.accounts.publisherListing },
            { name: 'Inactive Publisher', icon: <FaUserCheck />, path: '/inactive-publisher', permission: AUTH_CODE.accounts.publisherListing },
        ]
    },
    {
        name: 'User', icon: <BsPersonCircle />, path: '',
        children: [
            // { name: 'Create User', icon: <BsPersonPlus />, path: '/user/add', permission: AUTH_CODE.user.create },
            { name: 'User Listing', icon: <BiSolidUserDetail />, path: '/user', permission: AUTH_CODE.user.listing },
            // { name: 'Edit User', icon: <BsPersonCheckFill />, path: '/edit-publisher' },
            // { name: 'Active Users', icon: <BsPersonCheckFill />, path: '/active-publisher' },
        ]
    },
    {
        name: 'Meta Admin', icon: <RiAdminFill />, path: '',
        children: [
            { name: 'Content Management', icon: <GrDatabase />, path: '/content-management', permission: AUTH_CODE.contentManagement.listing },
            { name: 'Get ID Definition', icon: <FaArrowUpWideShort />, path: '/publisher-definition', permission: AUTH_CODE.defination.getIdDefination },
        ]
    },
    {
        name: 'Tech Admin', icon: <GrTechnology />, path: '',
        children: [
            { name: 'TR Panel Logs', icon: <TbReportSearch />, path: '/tr-panel-logs', permission: AUTH_CODE.userTracker.trPanelLogs },
            { name: 'Demand Partner 1 Setting', icon: <FaGears />, path: '/gamsetting', permission: AUTH_CODE.demandPartner.gamSettingListing },
            { name: 'User Role', icon: <LiaUserPlusSolid />, path: '/role', permission: AUTH_CODE.userRole.userRoleSetting },
        ]
    },
    {
        name: 'Reports', icon: <FaFileLines />, path: '',
        children: [
            { name: 'Demand Partner 1', icon: <FaChartSimple />, path: '/reporting-gam', permission: AUTH_CODE.gamReporting.gamReport, publishMenu: false },
        ]
    },
];

/**
 *   NOTE:  desable other view option on publisher menu not showing on publisher menu.
*/
export const PUBLISHER_MENU = (guid, id) => [
    { name: 'Publisher Info', icon: <LuFilePenLine />, path: `/publisher/info/${id}/${guid}`, permission: AUTH_CODE.accounts.publisherInfo },
    { name: 'Invoice Setting', icon: <LuFileCog />, path: `/invoice-setting/${id}/${guid}`, permission: AUTH_CODE.invoiceSetting.createUpdateInvoiceSetting },
    { name: 'Gam Setting', icon: <LuFileTerminal />, path: `/publisher/gam-setting/${id}/${guid}`, permission: AUTH_CODE.gamSetting.createUpdateGamSetting },
    { name: 'Manage Adplacement', icon: <LuFileType2 />, path: `/publisher/adplacement-list/${id}/${guid}`, permission: AUTH_CODE.adPlacement.adPlacementListing },
    { name: 'Manage Instream Ad', icon: <LuFileScan />, path: `/publisher/instream-ad-list/${id}/${guid}`, permission: AUTH_CODE.instreamAdSetup.instreamListing },
    { name: 'Manage Instream Setting', icon: <LuFileSliders />, path: `/publisher/instream-setting-list/${id}/${guid}`, permission: AUTH_CODE.instreamTagSetting.manageInstreamSetting },
    { name: 'Manage Invoice', icon: <LuFileSymlink />, path: `/publisher/invoice-list/${id}/${guid}`, permission: AUTH_CODE.publisherInvoice.invoiceListing },
    { name: 'Manage Publisher Invoice', icon: <LuFileUser />, path: `/invoice-list/${id}/${guid}`, permission: AUTH_CODE.financeInvoice.invoiceListing },
];

// export const PUBLISHER_MENU = (guid, id) => [
//     { name: 'Publisher Info', icon: <LuFilePenLine />, path: `/publisher/info/${id}/${guid}`, permission: AUTH_CODE.accounts.publisherInfo },
//     loginUser?.accountType != 1 ? { name: 'Manage Instream Ad', icon: <LuFileScan />, path: `/publisher/instream-ad-list/${id}/${guid}`, permission: AUTH_CODE.instreamAdSetup.instreamListing } : "",
//     loginUser?.accountType != 1 ? { name: 'Manage Instream Setting', icon: <LuFileSliders />, path: `/publisher/instream-setting-list/${id}/${guid}`, permission: AUTH_CODE.instreamTagSetting.manageInstreamSetting } : "",
//     loginUser?.accountType != 1 ? { name: 'Invoice Setting', icon: <LuFileCog />, path: `/invoice-setting/${id}/${guid}`, permission: AUTH_CODE.invoiceSetting.createUpdateInvoiceSetting } : "",
//     { name: 'Manage Invoice', icon: <LuFileSymlink />, path: `/publisher/invoice-list/${id}/${guid}`, permission: AUTH_CODE.publisherInvoice.invoiceListing },
//     { name: 'Manage Adplacement', icon: <LuFileType2 />, path: `/publisher/adplacement-list/${id}/${guid}`, permission: AUTH_CODE.adPlacement.adPlacementListing },
//     loginUser?.accountType != 1 ? { name: 'Manage Publisher Invoice', icon: <LuFileUser />, path: `/invoice-list/${id}/${guid}`, permission: AUTH_CODE.financeInvoice.invoiceListing } : "",
//     loginUser?.accountType != 1 ? { name: 'Gam Setting', icon: <LuFileTerminal />, path: `/publisher/gam-setting/${id}/${guid}`, permission: AUTH_CODE.gamSetting.createUpdateGamSetting } : ""
// ];
